import moment from 'moment'
moment.updateLocale('en', {
  week: {
    dow: 1, // 将星期一作为每周的第一天
  },
})
export const getYear = (value) => {
  return value ? moment(value).format('yyyy') : ''
}
export const getMonth = (value, format = 'yyyy-MM') => {
  return value ? moment(value).format(format) : ''
}
export const getDate = (value) => {
  return value ? moment(value).format('yyyy-MM-DD') : ''
}
export const getDateTime = (value, format) => {
  return value
    ? moment(value).format(format ? format : 'yyyy-MM-DD HH:mm:ss')
    : ''
}
export const getDateFormat = (value, format) => {
  return value ? moment(value).format(format ? format : 'yy.MM.DD') : ''
}

